<template>
  <div>


    <!-- Assign Distributor Modal -->
    <div v-show="false">{{ runAssignment }}</div>
    <div class="modal fade bg-[rgba(0, 0, 0, 0.5)] colored-header colored-header-primary" id="mod-assign-distributor"
      role="dialog">
      <div class="modal-dialog max-w-[500px] w-full relative">
        <div class="modal-content p-[24px]">
          <div class="flex items-start justify-between">
            <h4 class="text-[18px] leading-[28px] font-bold text-[#353535] mb-[4px]">
              Assign Distributor
            </h4>
            <button class="text-2xl" type="button" data-dismiss="modal" aria-hidden="true" @click="reset">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="flex flex-col gap-[16px] mt-[16px]">
              <div v-if="distributorAssignmentError" class="col-12 alert alert-danger">
                {{ distributorAssignmentError }}
              </div>
              <div>
                <input
                  class="w-full px-[16px] py-[12px] text-[14px] placeholder-gray-[#81868c] border-[0.5px] border-[#d0d5dd] outline-none rounded-[8px]"
                  placeholder="Search for a distributor" type="text" v-model="searchFilters.searchDistributors" />

                <div v-if="filteredAssignments.length == 0">
                  <div class="text-[16px] leading-[19.36px] font-normal text-[#353535] text-center my-[5px]">
                    No matching records
                  </div>
                </div>
                <div v-else class="w-full"
                  style="height: 400px; overflow-y: scroll; border: 1px solid #d0d5dd; padding: 15px; margin-top: 15px; border-radius: 10px;">
                  <ol>
                    <li v-for="(item, index) in filteredAssignments.filter((v) =>
                      v.text
                        .toLowerCase()
                        .match(searchFilters.searchDistributors.toLowerCase())
                    )" :key="item.name">
                      <div class="flex items-center gap-[12px]" :class="[
                        index === 0 ? '' : 'mt-[16px]',
                        index === filteredAssignments.length - 1
                          ? ''
                          : 'border-b',
                      ]">
                        <input type="checkbox" class="custom-checkbox" :id="'checkbox-' + index" :name="item.text"
                          :checked="item.selected" @click="item.selected = !item.selected" />
                        <label class="text-[16px] pt-[7px] leading-[30px] font-normal text-[#353535] cursor-pointer"
                          :for="'checkbox-' + index">
                          {{ item.text }}
                        </label>
                      </div>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div class="my-[15px] flex gap-2 items-center justify-center">
            <button
              class="border border-solid border-[#96a0b5] text-[#96a0b5] px-[24px] py-[16px] w-full rounded-[10px]"
              type="button" data-dismiss="modal" @click="reset">
              Cancel
            </button>
            <button :disabled="isBusyModal"
              class="border-[1px] bg-[#2463eb] text-white border-solid px-[24px] py-[16px] w-full rounded-[10px]"
              type="button" @click.prevent="assignDistributors">
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Assign Group Modal -->
    <div class="modal fade bg-[rgba(0, 0, 0, 0.5)] colored-header colored-header-primary" id="mod-assign-group"
      role="dialog">
      <div class="modal-dialog max-w-[500px] w-full relative">
        <div class="modal-content p-[24px]">
          <div class="flex items-start justify-between">
            <h4 class="text-[18px] leading-[28px] font-bold text-[#353535] mb-[4px]">
              Assign Group
            </h4>
            <button class="text-2xl" type="button" data-dismiss="modal" aria-hidden="true">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="flex flex-col gap-[16px] mt-[16px]">
              <!-- <div
                v-if="groupAssignmentError"
                class="col-12 alert alert-danger"
              >
                {{ groupAssignmentError }}
              </div> -->
              <div>
                <input
                  class="w-full px-[16px] py-[12px] text-[14px] placeholder-gray-[#81868c] border-[0.5px] border-[#d0d5dd] outline-none rounded-[8px]"
                  placeholder="Search for a group" type="text" v-model="searchFilters.searchGroups" />
                <div v-if="filteredAssignments.length == 0" class="col-12">
                  <div class="text-[16px] leading-[19.36px] font-normal text-[#353535] text-center my-[5px]">
                    No matching records
                  </div>
                </div>
                <div v-else class="w-full" style="height: 320px; overflow-y: scroll; border: 1px solid #eee;">
                  <ol>
                    <li v-for="item in filteredAssignments" :key="item.text">
                      <div class="flex flex-col gap-[16px] mt-[16px]">
                        <input type="checkbox" :name="item.text" :checked="item.selected"
                          @click="item.selected = !item.selected" />
                        <label class="text-[16px] leading-[19.36px] font-normal text-[#353535]" :for="item.text">
                          {{ item.text }}
                        </label>
                      </div>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div class="my-[15px] flex gap-2 items-center justify-center">
            <button
              class="border border-solid border-[#96a0b5] text-[#96a0b5] px-[24px] py-[16px] w-full rounded-[10px]"
              type="button" data-dismiss="modal">
              Cancel
            </button>
            <button :disabled="isBusyModal"
              class="border-[1px] bg-[#2463eb] text-white border-solid px-[24px] py-[16px] w-full rounded-[10px]"
              type="button" @click.prevent="assignGroups">
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Assign State Modal -->
    <div class="modal fade bg-[rgba(0, 0, 0, 0.5)] colored-header colored-header-primary" id="mod-assign-state"
      role="dialog">
      <div class="modal-dialog max-w-[500px] w-full relative">
        <div class="modal-content p-[24px]">
          <div class="flex items-start justify-between">
            <h4 class="text-[18px] leading-[28px] font-bold text-[#353535] mb-[4px]">
              Assign State
            </h4>
            <button class="text-2xl" type="button" data-dismiss="modal" aria-hidden="true">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="flex flex-col gap-[16px] mt-[16px]">
              <!-- <div
                v-if="stateAssignmentError"
                class="col-12 alert alert-danger"
              >
                {{ stateAssignmentError }}
              </div> -->
              <div>
                <input
                  class="w-full px-[16px] py-[12px] text-[14px] placeholder-gray-[#81868c] border-[0.5px] border-[#d0d5dd] outline-none rounded-[8px]"
                  placeholder="Search for a state" type="text" v-model="searchFilters.searchStates" />
                <div v-if="filteredAssignments.length == 0" class="col-12">
                  <div class="text-[16px] leading-[19.36px] font-normal text-[#353535] text-center my-[5px]">
                    No matching records
                  </div>
                </div>
                <div v-else class="w-full" style="height: 320px; overflow-y: scroll; border: 1px solid #eee;">
                  <ol>
                    <li v-for="item in filteredAssignments" :key="item.text">
                      <div class="flex flex-col gap-[16px] mt-[16px]">
                        <input type="checkbox" :name="item.text" :checked="item.selected"
                          @click="item.selected = !item.selected" />
                        <label class="text-[16px] leading-[19.36px] font-normal text-[#353535]" :for="item.text">
                          {{ item.text }}
                        </label>
                      </div>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div class="my-[15px] flex gap-2 items-center justify-center">
            <button
              class="border border-solid border-[#96a0b5] text-[#96a0b5] px-[24px] py-[16px] w-full rounded-[10px]"
              type="button" data-dismiss="modal">
              Cancel
            </button>
            <button :disabled="isBusyModal"
              class="border-[1px] bg-[#2463eb] text-white border-solid px-[24px] py-[16px] w-full rounded-[10px]"
              type="button" @click.prevent="assignStates">
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Assign team -->
    <div class="modal fade bg-[rgba(0, 0, 0, 0.5)] colored-header colored-header-primary" id="mod-assign-team"
      role="dialog">

      <div class="modal-dialog max-w-[500px] w-full relative">
        <div class="modal-content p-[24px]">
          <div class="flex items-start justify-between">
            <h4 class="text-[18px] leading-[28px] font-bold text-[#353535] mb-[4px]">
              Add Managed Team Member
            </h4>
            <button class="text-2xl" type="button" data-dismiss="modal" aria-hidden="true" @click="resetTeam">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="flex flex-col gap-[16px] mt-[16px]">
              <div v-if="teamAssignmentError" class="col-12 alert alert-danger">
                {{ teamAssignmentError }}
              </div>
              <div>
                <label class="text-[16px] pt-[7px] leading-[30px] font-normal text-[#353535]">Add Criteria</label>
                <select
                  class="border border-[#D0D5DD] px-[14px] py-[12px] rounded-[8px] w-full text-[#96A0B5] outline-none custom-select custom-select-lg"
                  placeholder="Select an option" v-model="searchFilters.managerSearchCriteria"
                  @change="onChange($event)">
                  <option value="">Select an option</option>
                  <!-- <option value="all">All Managers</option> -->
                  <option value="distributor">Distributor Managers</option>
                  <!-- <option value="group">Group Managers</option>
                  <option value="state">State Managers</option> -->
                </select>
              </div>
              <div class="">
                <div class="">
                  <input
                    class="border border-[#D0D5DD] px-[14px] py-[12px] rounded-[8px] w-full text-[#96A0B5] outline-none"
                    placeholder="Search for a team member" type="text" v-model="searchFilters.searchTeams" />
                  &nbsp;<br />
                  <div class="w-full"
                    style="height: 350px; overflow-y: scroll; border: 1px solid #d0d5dd; padding: 15px; margin-top: 15px; border-radius: 10px;">
                    <ol>
                      <li v-for="(item, index) in filteredAssignments" :key="item.name">
                        <div class="flex items-center gap-[12px]" :class="[
                          index === 0 ? '' : 'mt-[16px]',
                          index === filteredAssignments.length - 1
                            ? ''
                            : 'border-b',
                        ]">
                          <input type="checkbox" class="custom-checkbox" :id="'checkbox-' + index" :name="item.text"
                            :checked="item.selected" @click="item.selected = !item.selected" />
                          <label class="text-[16px] pt-[7px] leading-[30px] font-normal text-[#353535]"
                            :for="'checkbox-' + index">
                            {{ item.text }}
                          </label>
                        </div>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="my-[15px] flex gap-2 items-center justify-center">
            <button
              class="border border-solid border-[#96a0b5] text-[#96a0b5] px-[24px] py-[16px] w-full rounded-[10px]"
              @click="resetTeam" type="button" data-dismiss="modal">
              Cancel
            </button>
            <button :disabled="isBusyModal"
              class="border-[1px] bg-[#2463eb] text-white border-solid px-[24px] py-[16px] w-full rounded-[10px]"
              type="button" @click.prevent="assignTeams">
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */

import moment from "moment";
import { helper } from "@/helper";
import SystemPermissions from "@/permissions";
import Select2 from "@/components/Select2";
import Pagination from "../Pagination.vue";
export default {
  props: ["selecteduser", "mappingType", "openAssignModal", "openTeamModal"],
  mixins: [SystemPermissions.Mixin],
  name: "settingsTeam",
  components: {
    Select2,
    Pagination,
  },
  data() {
    return {
      filter: {
        status: "0",
        role: "0",
        qry: "",
      },

      searchFilters: {
        searchDistributors: "",
        searchGroups: "",
        searchStates: "",
        searchTeams: "",
        managerSearchCriteria: "",
      },

      isBusy: false,
      isBusyModal: false,

      editingUser: {
        id: null,
        emailAddress: null,
        phoneNumber: null,
        lastName: null,
        otherNames: null,
        roleId: null,
        staffId: null,
      },

      modalUser: {
        id: null,
        emailAddress: null,
        lastName: null,
        otherNames: null,
      },

      userMappings: [],

      v2: {
        phoneNumber: false,
        phoneNumberValid: false,
        emailAddressValid: false,
        lastname: false,
        othernames: false,
        role: false,
      },

      assignments: [],
      managers: [],

      v8: {
        selectedOption: false,
      },

      selectedOption: "",
      assignmentType: "",
      distributorAssignmentError: null,
      stateAssignmentError: null,
      groupAssignmentError: null,
      teamAssignmentError: null,
      Distributors: [],
    };
  },

  computed: {
    user: function () {
      return this.$store.state.currentUser;
    },

    enableInviteOption: function () {
      return this.modalUser.emailAddress && this.modalUser.phoneNumber;
    },
    runAssignment() {
      if (this.selecteduser && this.mappingType) {
        this.getAssignments();
        return true;
      }
      return false;
    },
    computedKey() {
      return this.assignments.length;
    },
    filteredAssignments() {
      let vm = this;
      var searchParam = null;
      if (vm.assignmentType === "Distributor")
        searchParam = vm.searchFilters.searchDistributors;
      else if (vm.assignmentType === "Group")
        searchParam = vm.searchFilters.searchGroups;
      if (vm.assignmentType === "State")
        searchParam = vm.searchFilters.searchStates;
      if (vm.assignmentType === "Team")
        searchParam = vm.searchFilters.searchTeams;

      let filteredItems = vm.sortedAssignments.filter(item => item.text && item.text.trim() !== "");

      if (!searchParam) {
        return filteredItems;
      }

      return filteredItems.filter((a) => {
        return a.text.toLowerCase().indexOf(searchParam.toLowerCase()) != -1;
      });
    },
    sortedAssignments: function () {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;

        return 0;
      }

      var sortedArr = this.assignments.sort(compare);

      return sortedArr;
    },
  },

  methods: {
    assignDistributors() {
      this.isBusyModal = true;
      this.isBusy = true;

      if (this.validateAssignment("distributor")) {
        var selectedIds = this.assignments
          .filter((obj) => obj.selected == true)
          .map((ele) => ele.id);

        let data = {
          userId: this.selecteduser.id,
          mappingType: "Distributor",
          mappingValues: selectedIds,
        };

        this.$http
          .post("/SalesUsers/mapSalesUser/", data)
          .then(function (res) {
            this.isBusyModal = false;
            $("#mod-assign-distributor").modal("hide");
            this.$toast.success("Distributor(s) Mapped successfully.", {
              icon: true,
              rtl: false,
            });
            this.openAssignModal();
          })
          .catch(function () {
            this.isBusy = false;
            this.isBusyModal = false;
          });
      } else {
        this.isBusy = false;
        this.isBusyModal = false;
      }
    },
    assignTeams() {
      this.isBusyModal = true;
      this.isBusy = true;

      if (this.validateAssignment("team")) {
        var selectedIds = this.assignments
          .filter((obj) => obj.selected == true)
          .map((ele) => ele.id);
        let data = {
          userId: this.selecteduser.id,
          mappingType: "Team",
          mappingValues: selectedIds,
        };
        this.$http
          .post("/SalesUsers/mapSalesUser/", data)
          .then(function (res) {
            this.isBusyModal = false;
            $("#mod-assign-team").modal("hide");
            this.$toast.success("Team(s) Mapped successfully.", {
              icon: true,
              rtl: false,
            });
            this.openTeamModal();
            this.resetTeam();
          })
          .catch(function () {
            this.isBusy = false;
            this.isBusyModal = false;
            this.resetTeam();
          });
      } else {
        this.isBusy = false;
        this.isBusyModal = false;
        this.resetTeam();
      }
    },
    assignStates() {
      this.isBusyModal = true;
      this.isBusy = true;

      if (this.validateAssignment("state")) {
        $("#mod-assign-state").modal("hide");

        var selectedIds = this.assignments
          .filter((obj) => obj.selected == true)
          .map((ele) => ele.id);

        let data = {
          userId: this.selecteduser.id,
          mappingType: "State",
          mappingValues: selectedIds,
        };

        this.$http
          .post("/SalesUsers/mapSalesUser/", data)
          .then(function (res) {
            this.isBusyModal = false;
          })
          .catch(function () {
            this.isBusy = false;
            this.isBusyModal = false;
          });
      } else {
        this.isBusy = false;
        this.isBusyModal = false;
      }
    },
    assignGroups() {
      this.isBusyModal = true;
      this.isBusy = true;

      if (this.validateAssignment("group")) {
        $("#mod-assign-group").modal("hide");

        var selectedIds = this.assignments
          .filter((obj) => obj.selected == true)
          .map((ele) => ele.id);

        let data = {
          userId: this.selecteduser.id,
          mappingType: "Group",
          mappingValues: selectedIds,
        };

        this.$http
          .post("/SalesUsers/mapSalesUser/", data)
          .then(function (res) {
            this.isBusyModal = false;
          })
          .catch(function () {
            this.isBusy = false;
            this.isBusyModal = false;
          });
      } else {
        this.isBusy = false;
        this.isBusyModal = false;
      }
    },

    validateAssignment(type) {
      let isValid = true;

      this.teamAssignmentError = null;
      this.stateAssignmentError = null;
      this.distributorAssignmentError = null;
      this.groupAssignmentError = null;

      var selectedIds = this.assignments.filter((obj) => obj.selected == true);
      if (selectedIds.length == 0) {
        if (type === "distributor")
          this.distributorAssignmentError =
            "Please select at least one record for assignment";
        if (type === "state")
          this.stateAssignmentError =
            "Please select at least one record for assignment";
        if (type === "group")
          this.groupAssignmentError =
            "Please select at least one record for assignment";
        if (type === "team")
          this.teamAssignmentError =
            "Please select at least one record for assignment";
        isValid = false;
      }

      return isValid;
    },

    getUserMappings(userId) {
      var a = true;

      this.$http
        .get("/SalesUsers/getMappings/" + userId)
        .then(function (res) {
          this.userMappings = res.body;
        })
        .catch(function () { });
    },
    getAssignments() {
      var a = true;
      this.$http
        .get(
          "/SalesUsers/getMappingsItemList/" +
          this.user.parentId +
          "/" +
          this.selecteduser.id +
          "?mappingType=" +
          this.mappingType
        )
        .then(function (res) {
          this.assignments = res.body;
        })
        .catch(function (err) { });
    },
    // i need to always remember that i hardcorded the managerType to distributor and should not forget to change it when other factor are added 
    getManagers(managerType) {
      return this.$http
        .get(
          "/SalesUsers/getMappingsItemList/" +
          this.user.parentId +
          "/" +
          this.selecteduser.id +
          "?mappingType=team&managerType=distributor"
        )
        .then((res) => {
          this.assignments = res.body;
          return res;
        })
        .catch((error) => {
          console.error("Error fetching managers:", error);
          return Promise.reject(error);
        });
    },
    reset() {
      this.searchFilters.searchDistributors = "";
      this.distributorAssignmentError = null;
    },
    resetTeam() {
      this.searchFilters.searchTeams = "";
      this.searchFilters.managerSearchCriteria = "";
      this.teamAssignmentError = null;
      this.assignments = [];
    },
    onChange(event) {
      const selectedItems = this.assignments
        .filter(item => item.selected)
        .map(item => item.id);
      this.assignments = [];
      this.searchFilters.searchTeams = "";
      var val = event.target.value;
      if (val && val != "") {
        this.getManagers(this.editingUser.id, val)
          .then(() => {
            this.assignments.forEach(item => {
              if (selectedItems.includes(item.id)) {
                item.selected = true;
              }
            });
          });
      }
    },
    formatDate(date) {
      return moment(date).format("lll");
    },
  },
};
</script>
<style scoped>
.custom-checkbox {
  width: 24px;
  height: 18.9px;
  appearance: none;
  border: 1px solid #96a0b5;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  outline: none;
  transition: background-color 0.2s ease-in-out;
}

.custom-checkbox:checked {
  background-color: rgba(36, 99, 235, 0.5);
  border-color: rgba(36, 99, 235, 1);
}

.custom-checkbox:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #2463eb;
  font-size: 14px;
}
</style>
